import { render, staticRenderFns } from "./container-page.vue?vue&type=template&id=bffb2692"
import script from "./container-page.vue?vue&type=script&lang=js"
export * from "./container-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports